module.exports = __webpack_public_path__ + "static/media/roku-logo.54f2953a.svg";